import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shuffle",
  "use": "icon-shuffle-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shuffle\"><path d=\"M29.1651 39.8653V37.5961H35.8766L26.7728 28.5231L28.3535 26.8924L37.4997 35.977V29.2616H39.7689V39.8653H29.1651ZM9.83047 39.673L8.23047 38.0423L35.8997 10.373H29.1651V8.1039H39.7689V18.6885H37.4997V12.0038L9.83047 39.673ZM19.442 21.0692L8.24972 9.9077L9.86122 8.2962L21.0727 19.4577L19.442 21.0692Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol